import axios from './axiosInstances/axiosInstance';

export const getLastBasket = () => {
  return axios.get(`baskets/lastBasket`);
};
